import { render, staticRenderFns } from "./Mensajes.vue?vue&type=template&id=4b8c79fa"
import script from "./Mensajes.vue?vue&type=script&lang=js"
export * from "./Mensajes.vue?vue&type=script&lang=js"
import style0 from "./Mensajes.vue?vue&type=style&index=0&id=4b8c79fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports